// extracted by mini-css-extract-plugin
export var closeButton = "_md-2";
export var closeButtonIcon = "_md-3";
export var lightboxContent = "_md-1";
export var lightboxOverlay = "_md-0";